// extracted by mini-css-extract-plugin
export default {"promotion-group":"promotion-group_promotion-group__yAkiN","block":"promotion-group_block__8obxs","title":"promotion-group_title__S0Wul"};